var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",class:{'calendar-icon' : _vm.icon},attrs:{"type":"text","required":_vm.required,"name":_vm.name,"data-validator-trigger":"datepicker.select"}})}
var staticRenderFns = []

export { render, staticRenderFns }